export default "__VITE_ASSET__F93Ts36t__"